import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import FolderPlus from '@scope/scope-one-ui/assets/icons/folder-plus.svg';
import { Box, Typography, Divider } from '@scope/scope-one-ui/core';
import { COLORS } from '@scope/scope-one-ui/theme';
import { useNavigate } from 'react-router-dom';
import { LastAddedWidgetProps } from './LastAddedWidget.d';
import {
  ScrollableArea,
  WidgetItem,
  WidgetItemSubtitleDescription,
  WidgetStyled,
} from './PortfolioSummary.styled';
import { SummaryLastAddedType } from '../../types';

const LastAddedTypeRoute = {
  entity: 'entities',
  instrument: 'instruments',
  fund: 'funds',
};

export const LastAddedWidget: FC<LastAddedWidgetProps> = ({ lastAdded, portfolioId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToTab = (artifactId: string, type: SummaryLastAddedType) => {
    navigate(
      `/portfolios/${portfolioId}/${LastAddedTypeRoute[type]}/${artifactId}?companyModule=summary-card`,
    );
  };

  const convertToUpperCase = (text: string) =>
    text ? `${text.charAt(0).toUpperCase()}${text.slice(1)}` : '';

  return (
    <WidgetStyled title={t('PORTFOLIO.LAST_ADDED')}>
      <ScrollableArea showScroll={lastAdded.length > 3}>
        {lastAdded.map((item) => (
          <Box
            key={item.artifactId}
            display="flex"
            flexDirection="column"
            onClick={() => goToTab(item.artifactId, item.type)}
          >
            <WidgetItem py={3}>
              <Box mx={2} display="flex" alignItems="start">
                <FolderPlus width="18px" height="17px" color={COLORS.typography.main} />
                <Box ml={1}>
                  <Typography variant="h3">{item.name}</Typography>
                  <Box display="flex" alignItems="center" mt={0.25}>
                    <Box display="flex">
                      <WidgetItemSubtitleDescription color={COLORS.typography.main} variant="body2">
                        {t('PORTFOLIO.TYPE')}:
                      </WidgetItemSubtitleDescription>
                      <Typography variant="body2">{convertToUpperCase(item.type)}</Typography>
                    </Box>
                    <Box px={1}>
                      <Typography color={COLORS.typography.main} variant="body2">
                        |
                      </Typography>
                    </Box>
                    <Box display="flex">
                      <WidgetItemSubtitleDescription color={COLORS.typography.main} variant="body2">
                        {item.type === 'entity' ? t('PORTFOLIO.COUNTRY') : t('PORTFOLIO.ISIN')}:
                      </WidgetItemSubtitleDescription>
                      <Typography variant="body2">
                        {item.type === 'entity' ? item.country : item.isin}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </WidgetItem>
            <Box mx={2}>
              <Divider />
            </Box>
          </Box>
        ))}
      </ScrollableArea>
    </WidgetStyled>
  );
};

export default LastAddedWidget;
